<template>
  <div class="trigger">
    <div class="header">
      {{ $t("point.trigger") }}
    </div>
    <div class="body" v-loading="loading">
      <el-form label-position="top" label-width="100px" ref="form">
        <el-row>
          <el-form-item :label="' '">
            <el-select @change="save" @remove-tag="removed" multiple v-model="selectedTriggers" placeholder="Select">
              <el-option v-for="item in triggers.map((x) => x.macAddress)" :label="item" v-bind:key="item"
                :value="item"></el-option>
            </el-select>
          </el-form-item>
        </el-row>

      </el-form>
    </div>
    <br />
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import dayjs from "dayjs-ext";
export default {
  name: "Trigger",
  props: ["device"],
  data() {
    return {
      // showEditProfile: false
      bodyStyle: {
        padding: "5px",
      },
      loading: false,
      selectedTriggers: [],
    };
  },
  async created() {
    this.init();
  },
  computed: {
    ...mapState("trigger", ["triggers", "triggerLoading"]),


  },
  methods: {
    async init() {
      await this.getTriggers();
      this.selectedTriggers = this.triggers.filter(x => x.assignedDevices.some(x => x.macAddress == this.device)).map(x => x.macAddress);
      console.log("triggers", this.selectedTriggers);
    },
    ...mapActions("trigger", ["getTriggers", "removeDevice", "assignDevice"]),

    formatDate(value, direction) {
      let d = dayjs(value).diff(dayjs(), "m");
      return direction == "past" ? -1 * d : d;
    },

    async removed(removedDevice) {

      this.loading = true;

      await this.removeDevice({ trigger: removedDevice, device: this.device });
      this.loading = false;


    },
    async save() {
      this.loading = true;
      for (let i = 0; i < this.selectedTriggers.length; i++) {
        await this.assignDevice({ trigger: this.selectedTriggers[i], device: this.device });

      }

      this.loading = false;
      this.getTriggers();
    },
    showEditForm() {

    },
  },
  watch: {
    "device": function () {
      this.init();
    }
  }
};
</script>
<style>
.trigger .el-form--label-top .el-form-item__label {
  padding-bottom: 0px;
}

.trigger .el-input-number__increase {
  right: -19px;
}

.trigger .el-form-item__label {
  line-height: 0px;
  font-size: 12px;
}

.trigger .el-form-item {
  margin-bottom: 18px;
}

.trigger .el-input {
  width: 200px;
}

.info {
  padding: 10px;
  color: #232323;
  font-style: italic;
  font-size: 10px;
}

.point .el-card__header {
  padding: 10px;
}
</style>
<style  scoped>
.trigger .header:hover .edit,
.el-card__header:hover .edit {
  opacity: 1;
}

.edit {
  display: inline-block;
  opacity: 0.5;
}

.trigger {
  padding: 10px;
}

.trigger .body li {
  list-style-type: none;
  margin-bottom: 10px;
}

.trigger .header {
  font-size: 14px;
  padding-bottom: 5px;
}

.path {
  margin-left: 5px;
  line-height: -20px;
  font-size: 12px;
  color: gray;
}

.name {
  font-size: 20px;
  font-weight: bold;
}

.point {
  margin-bottom: 10px;
}
</style>